const navigations = document.querySelectorAll('.ce_rsce_navigation');

navigations.forEach(function(navigation) {
    const mobileButton = navigation.querySelector('.menuButton');
    const mobileNav = navigation.querySelector('.mobile');

    if (!mobileButton || !mobileNav) {
        return;
    }

    function setMobileMenuState(isOpen) {
        mobileButton.classList.toggle('active', isOpen);
        mobileNav.classList.toggle('active', isOpen);
        mobileButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        mobileButton.setAttribute('aria-label', isOpen ? 'Navigation schließen' : 'Navigation öffnen');
        mobileNav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        document.body.style.overflow = isOpen ? 'hidden' : '';
    }

    function closeMobileMenu() {
        setMobileMenuState(false);
    }

    mobileButton.addEventListener('click', function(event) {
        event.preventDefault();
        setMobileMenuState(!mobileNav.classList.contains('active'));
    });

    const mobileLinks = mobileNav.querySelectorAll('a');
    
    mobileLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            if (link.parentElement.classList.contains('submenu')) {
                return; 
            }
            
            closeMobileMenu();
        });
    });

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && mobileNav.classList.contains('active')) {
            closeMobileMenu();
            mobileButton.focus();
        }
    });

    document.addEventListener('click', function(event) {
        if (!mobileNav.classList.contains('active')) {
            return;
        }

        if (navigation.contains(event.target)) {
            return;
        }

        closeMobileMenu();
    });

    const mobileSubmenus = mobileNav.querySelectorAll('.submenu');

    mobileSubmenus.forEach(function(submenu) {
        submenu.addEventListener('click', function(e) {
            const clickedLink = e.target.closest('a');

            if (clickedLink && clickedLink.parentElement === submenu) {
                e.preventDefault();
            }

            submenu.classList.toggle('open');
            e.stopPropagation();
        });
    });
});
